import image1 from "../assets/coach.jpg";
import image2 from "../assets/coach1.jpg";
import image3 from "../assets/coach3.jpg";
import image4 from "../assets/coach4.jpg";

export const testimonialsData = [
  {
    id:'1',
    image: image1,
    review:
      "I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body!",
    name: 'MATHEW HENDRICKSON',
    status : 'Personal Trainer '
  },
  {
    id:'2',
    image: image2,
    review: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi ipsam, ab itaque nam perferendis impedit sint ',
    name: 'JEENY KEVIN',
    status: 'COACH'
  },
  {
    id:'3',
    image : image3,
    review:' Lorem ipsum dolor sit, amet consectetur adipisicing elit. Minima aspernatur quod voluptatem',
    name: 'FRANKLIN',
    status: "Personal Trainer  "
  },
   {
    id:'4',
    image : image4,
    review:' Lorem ipsum dolor sit, amet consectetur adipisicing elit. Minima aspernatur quod voluptatem',
    name: 'TONY',
    status: "COACH"
  }
];
